export default function(_) {
  for (var s={}, i=0, n=_.length; i<n; ++i) s[_[i]] = true;
  return s;
}



//////////////////
// WEBPACK FOOTER
// ./node_modules/vega-util/src/toSet.js
// module id = 832
// module chunks = 0